export default class ExtranetApiDocumentationIndex {
    constructor() {
        this.sidebar = document.getElementById('apiDocSidebar');
        this.content = document.getElementById('apiDocContent');
        this.navLinks = document.querySelectorAll('.api-doc-nav-link');
        this.sections = document.querySelectorAll('.api-doc-section');

        this.setSidebarOffset();
        this.bindEvents();
        this.highlightCurrentSection();
    }

    // Measure the combined height of the fixed navbars and apply it as CSS custom
    // properties so the sidebar top + height always match the actual layout.
    setSidebarOffset() {
        const topbar  = document.querySelector('.navbar-custom');
        const topnav  = document.querySelector('.topnav');

        // Use getBoundingClientRect so we get the rendered bottom edge of the
        // lowest fixed element, which is the exact value sticky/fixed needs.
        const topbarBottom  = topbar  ? topbar.getBoundingClientRect().bottom  : 0;
        const topnavBottom  = topnav  ? topnav.getBoundingClientRect().bottom  : topbarBottom;
        const offset        = Math.max(topbarBottom, topnavBottom);

        if (this.sidebar && offset > 0) {
            this.sidebar.style.setProperty('--api-sidebar-top',    `${offset}px`);
            this.sidebar.style.setProperty('--api-sidebar-height', `calc(100vh - ${offset}px)`);
        }
    }

    bindEvents() {
        // Sidebar link clicks — smooth scroll
        this.navLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = link.getAttribute('href').substring(1);
                const targetSection = document.getElementById(targetId);
                if (targetSection) {
                    // Account for the offset so the section isn't hidden under the sidebar
                    const offset = parseInt(
                        getComputedStyle(document.documentElement)
                            .getPropertyValue('--api-sidebar-top') || '130', 10
                    );
                    const top = targetSection.getBoundingClientRect().top + window.scrollY - offset - 16;
                    window.scrollTo({ top, behavior: 'smooth' });
                    this.setActiveLink(link);
                }
            });
        });

        // Scroll spy — highlight active section on scroll
        window.addEventListener('scroll', () => this.highlightCurrentSection(), { passive: true });

        // Recalculate on resize (handles mobile ↔ desktop transitions)
        window.addEventListener('resize', () => this.setSidebarOffset(), { passive: true });

        // Mobile sidebar toggle
        const toggleBtn = document.getElementById('apiDocSidebarToggle');
        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                if (this.sidebar) this.sidebar.classList.toggle('api-doc-sidebar-open');
            });
        }

        // Click-to-copy code blocks
        document.querySelectorAll('.api-doc-code-block pre').forEach(block => {
            block.style.cursor = 'pointer';
            block.title = 'Click to copy';
            block.addEventListener('click', () => {
                const code = block.querySelector('code');
                if (code && navigator.clipboard) {
                    navigator.clipboard.writeText(code.textContent).then(() => {
                        const prev = block.style.outline;
                        block.style.outline = '2px solid #5ba035';
                        setTimeout(() => { block.style.outline = prev; }, 600);
                    });
                }
            });
        });
    }

    setActiveLink(activeLink) {
        this.navLinks.forEach(l => l.classList.remove('active'));
        activeLink.classList.add('active');
    }

    highlightCurrentSection() {
        const offset = parseInt(
            this.sidebar?.style.getPropertyValue('--api-sidebar-top') || '130', 10
        ) + 24;

        let current = null;
        this.sections.forEach(section => {
            if (section.getBoundingClientRect().top <= offset) {
                current = section;
            }
        });

        if (current) {
            const id = current.getAttribute('id');
            this.navLinks.forEach(link => {
                link.classList.toggle('active', link.getAttribute('data-section') === id);
            });
        }
    }
}
